// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./wave-png-49470.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  background-color: #010826;
  height: 100vh;
  padding-top: 7%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

.glass {
  /* From https://css.glass */
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 8%;
  padding-top: 8%;
  padding-bottom: 15%;
  color: #b6b6b6 !important;
}

.form-control {
  background-color: #c3c8ca !important;
}
.errorLabel {
  font-size: 14px;
  color: red;
}

.info-section {
  color: #b6b6b6;
}`, "",{"version":3,"sources":["webpack://./src/components/login/index.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,eAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,2BAAA;EACA,oCAAA;EACA,kBAAA;EACA,yCAAA;EACA,0BAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACJ;;AAGA;EACI,oCAAA;AAAJ;AAMA;EACI,eAAA;EACA,UAAA;AAJJ;;AAOA;EACI,cAAA;AAJJ","sourcesContent":[".root {\n    background-color: #010826;\n    height: 100vh;\n    padding-top: 7%;\n    background-image: url(./wave-png-49470.png);\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.glass {\n    /* From https://css.glass */\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 5px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    padding: 8%;\n    padding-top: 8%;\n    padding-bottom: 15%;\n    color: #b6b6b6 !important;\n    // border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.form-control {\n    background-color:  #c3c8ca !important;\n    &:active {\n        // background-color: #fff !important;\n    }\n}\n\n.errorLabel {\n    font-size: 14px;\n    color: red;\n}\n\n.info-section {\n    color: #b6b6b6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
